<mat-dialog-content>
    <h3>Create a question for the category "{{currentCategory.name | titlecase}}"</h3>
    <div>
        <mat-form-field class="question">
            <input required matInput
                   [(ngModel)]="newQuestion.question" id="NewQuestionFaq">
            <mat-placeholder>Question</mat-placeholder>
            <mat-error>Please provide the question to be answered</mat-error>
        </mat-form-field>
    </div>
    <div>
        <mat-form-field class="answer" floatLabel='never'>
        <textarea required
                  cdkAutosizeMinRows="5"
                  cdkTextareaAutosize matInput
                  [(ngModel)]="newQuestion.answer" id="QuestionAnsFaq">
        </textarea>
            <mat-placeholder>Answer</mat-placeholder>
            <mat-error>Please provide the answer to the question</mat-error>
        </mat-form-field>
    </div>
</mat-dialog-content>
<mat-dialog-actions class="mat-dialog-actions">
    <button [mat-dialog-close]="newQuestion" color="primary" mat-raised-button id="QuestionFaqSave">Save</button>
    <button [mat-dialog-close]="closeDialog" color="primary" mat-raised-button id="QuestionFaqCancel">Cancel</button>
</mat-dialog-actions>
